module.exports = __webpack_public_path__ + "static/img/logo.796cd96.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.gif
// module id = IS4X
// module chunks = 20